import Vue from "vue";

const getDefaultState = () => {
  return {
    subspace: {
      name: "All Tasks",
      type: "TASK", // TASK, NOTE, CUSTOM
    }, // currently active subspace

    cachedSubspaces: {}, // Subspaces that have been loaded into the sidebar.

    savingInProgress: false, // Whether a subspace is currently being saved.

    subspaceNameInput: "", // Value of subspace name input field. Used to track changes.
    isCreatingSubspace: false, // Whether user is currently in the process of creating a subspace.

    subspaceDropdowns: {}, // Whether subspace dropdowns are open or closed.
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },
  setSubspaceNameInput(newValue) {
    state.subspaceNameInput = newValue;
  },
  setCreatingSubspace(newValue) {
    state.isCreatingSubspace = newValue;
  },

  syncSubspaceName(newValue) {
    state.subspace.name = newValue;
  },

  setSavingInProgress(newState) {
    state.savingInProgress = newState;
  },
  /**
   *
   * @param {Object} sidebarElement
   * @param {Object} sidebarElement.refID
   * @param {Object} sidebarElement.refName
   */
  setSubspaceBySidebarElement(sidebarElement) {
    const newSubspace = { _id: sidebarElement.refID };
    if (sidebarElement.refName) newSubspace.name = sidebarElement.refName;
    state.subspace = newSubspace;
  },

  setSubspace(subspace) {
    state.subspace = subspace;
  },

  clearSubspace() {
    state.subspace = {};
  },

  toggleSubspaceDropdown() {
    const currentlyActiveSubspaceID = state.subspace._id;
    if (!Object.hasOwn(state.subspaceDropdowns, currentlyActiveSubspaceID)) {
      Vue.set(state.subspaceDropdowns, currentlyActiveSubspaceID, true);
    } else {
      state.subspaceDropdowns[currentlyActiveSubspaceID] = false;
      delete state.subspaceDropdowns[currentlyActiveSubspaceID];
    }
  },

  closeAllSubspaceDropdowns() {
    Vue.set(state, "subspaceDropdowns", {});
  },
};

const SubspaceStore = { state, methods };
export default SubspaceStore;
